export class BlockNotasModel{
    idBlockNotas:number;
    idJardinPeriodo:number;
    contenido:string;

    constructor(){
        this.idBlockNotas = 0;
        this.idJardinPeriodo = 0;
        this.contenido = "";
    }
}

export class ResponseBlockNotasModel{
    payload:BlockNotasModel[];

    constructor(){
        this.payload = new Array<BlockNotasModel>();
    }
}
 